import { PricingQuotaConfiguration } from "./pricing-quota-configuration.model";

export class PricingInfoViewItem {
  private pricingKey: string;
  private maxPrice: number;
  private price: number;
  private created: string;
  private modified: string;
  private pricingQuotaConfiguration: PricingQuotaConfiguration;

  public getPricingKey(): string {
    return this.pricingKey;
  }

  public setPricingKey(pricingId: string): void {
    this.pricingKey = pricingId;
  }

  public getMaxPrice(): number {
    return this.maxPrice;
  }

  public setMaxPrice(maxPrice: number): void {
    this.maxPrice = maxPrice;
  }

  public getPrice(): number {
    return this.price;
  }

  public setPrice(price: number): void {
    this.price = price;
  }

  public resetPrices(): void {
    this.price = 0;
    this.maxPrice = 0;
  }

  public getCreated(): string {
    return this.created;
  }

  public setCreated(created: string): void {
    this.created = created;
  }

  public getModified(): string {
    return this.modified;
  }

  public setModified(modified: string): void {
    this.modified = modified;
  }

  public getPricingQuotaConfiguration(): PricingQuotaConfiguration {
    return this.pricingQuotaConfiguration;
  }

  public setPricingQuotaConfiguration(pricingQuotaConfiguration: PricingQuotaConfiguration): void {
    this.pricingQuotaConfiguration = pricingQuotaConfiguration;
  }
}
